module.exports = __webpack_public_path__ + "img/skyscraper.7bacc2a1.png";